import css from '../Approvals/css/view-modal.module.css';
import {AiOutlineFilePdf as PdfIcon} from 'react-icons/ai';
import styled from '@emotion/styled';
import EachPersonalField from './EachPersonField';
import Checkbox from '@mui/material/Checkbox';
import { CorporateBioData, CorporateDetailsProps, RefereeData} from './type';
import styles from "./css/styles.module.css";
import DocumentBar from './DocumentBar';
import { NotAvailable } from './styles';
import { FC } from 'react';


interface ComponentProps {
  data: CorporateBioData | undefined,
  referenceData: RefereeData[];
}


  const CorporateDetails: FC<ComponentProps> = ({ data, referenceData }) => {
  // const referenceData = data?.RefereeList || [];

  console.log(referenceData);
  
  

  return (
    <div className={css.contentDiv}>
      <p className={css.tltle}>Corporate Details</p>
      <EachQualificationContainer>
        <EachPersonalField
          style={{ width: "100%" }}
          label="Name Of Organization"
          value={data?.OrganizationName}
        />
        <EachPersonalField
          style={{ width: "100%" }}
          label="Contact Address"
          value={data?.ContactAddress}
        />
        <EachPersonalField
          label="Company's Phone Number "
          value={data?.CompanyPhone}
        />
        <EachPersonalField
          label="Mobile Number"
          value={data?.OtherPhone}
        />
        <EachPersonalField
          label="Company's Email Address"
          value={data?.CompanyEmail}
        />
        <EachPersonalField
          label="Alternative Email Address"
          value={data?.OtherEmail}
        />
        <EachPersonalField
          style={{ width: "100%" }}
          label="Nature OF Business"
          value={data?.BusinessNature}
        />

        <div style={{ width: "100%", marginBottom: "16px" }}>
          <label
            style={{
              fontWeight: "bold",
              marginBottom: "8px",
              display: "block",
            }}
          >
            Do you have members of your staff who are members of this institute?
          </label>
          <div style={{ display: "flex", gap: "40px" }}>
            <label>
              <Checkbox checked={data?.CIPMMember === true} readOnly /> Yes
            </label>
            <label>
              <Checkbox checked={data?.CIPMMember === false} readOnly /> No
            </label>
          </div>
        </div>

       <div style={{ width: "100%", marginTop: "5px", marginBottom:"10px" }}>
  <div className={styles.headingBar} style={{ marginBottom: "16px" }}>
    REFEREE Details
  </div>
          {referenceData.length > 0 ? (
            <table>
              <thead>
                <tr className={styles.tableHead}>
                  <th className={css.curEmpHeader}>Applicant name</th>
                  <th className={css.curEmpHeader}>RefereeMembershipNo</th>
                  <th className={css.curEmpHeader}>Status</th>
                  <th className={css.curEmpHeader}>Comment</th>
    
                </tr>
              </thead>
              <tbody>
                {referenceData.map((eR: RefereeData, index: number) => (
                  <tr key={index}>
                    <td>{eR?.ApplicantName || "N/A"}</td>
                    <td>{eR?.RefereeMembershipNo || "N/A"}</td>
                    <td>{eR?.Status || "N/A"}</td>
                    <td>{eR?.Comment || "N/A"}</td>
                    {/* <td>
                      <DocumentBar
                        hideScoreIntegration={false}
                        docName="REFEREE DOCUMENT"
                        documentUrl={eR?.RefereeLetterUrl}
                        onChange={() => {}}
                      />
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <NotAvailable>Not Available</NotAvailable>
          )}
        </div>
      </EachQualificationContainer>
    </div>
  );
};

export default CorporateDetails;

  const EachQualificationContainer = styled.div`
  width:100%;
  display:flex;
  flex-wrap:wrap;
  justify-content: space-between;
  row-gap:20px;
  column-gap:10px;
  & > span{
    width: 100%;

  }
  & > span > span{
      padding:7px 10px;
      background-color:#E0FAEE;
      font-weight: 600;
  }
  & > div{
    width:40%;    
  }
`   

  const StyledLink = styled.a`
    margin-bottom: 20px;
    width:100%;
    padding:10px;
    display: flex;
    gap:20px;
    border-radius: 5px;
    border:1px dashed #D0CECE;
    text-decoration:none;
    color:#222;
    cursor: pointer;
    & > span{
      display: flex;
      justify-content:center;
      align-items: center;
      font-size:25px;
    }
    & > div{
      display: flex;
      flex-direction: column;
      gap:10px;
    }
    & > div > span:first-of-type{
      font-size: 13px;
    }
    & > div > span:last-of-type{
      color:#7B7A7A;
    }
`;